<template>
  <div class="flex justify-content-between align-items-center bg-white p-3 border-round shadow-1 mb-2 mr-2">
    <!-- Ajuste visual 3: antes style="min-width: 0;" (dejaba que el grupo se encogiera y cortaba el nombre). Ahora el grupo izquierdo no se encoge -->
    <div class="flex align-items-center gap-3 flex-shrink-0">
      <ZapiBackButton />
      <div class="flex align-items-center gap-2">
        <!-- Imagen de Logo dinámico desde la Empresa -->
        <!-- revision_capturas.md (a): si /empresa falla (sin conexión) o todavía no llegó, se usa el logo del catálogo local (prop logoLocal). Antes:
        <img v-if="empresa && empresa.logo" :src="'data:image/png;base64, ' + empresa.logo" alt="Logo Empresa" style="height: 38px; border-radius: 4px;" /> -->
        <img v-if="logoVisible" :src="'data:image/png;base64, ' + logoVisible" alt="Logo Empresa" style="height: 38px; border-radius: 4px;" data-testid="pos-logo" />
        <span class="text-3xl zapi-font zapi-text-red font-bold ml-2">POS</span>
      </div>
      <!-- Ajuste visual 2: antes era <ZapiBadgePill :label="nombreSucursal" severity="danger" /> (pequeño). Ahora grande, con «…» y el nombre completo en el tooltip -->
      <!-- Ajuste visual 3: antes <ZapiBadgePill … grande v-tooltip.bottom="nombreSucursal" />. El tooltip lo pone ahora ZapiBadgePill, solo si el nombre se corta -->
      <ZapiBadgePill :label="nombreSucursal" severity="danger" grande />
    </div>

    <!-- Ajuste visual 3: antes class="… w-full …" (le quitaba el sitio al grupo izquierdo). Ahora ocupa lo que queda y puede encogerse -->
    <div class="flex align-items-center justify-content-end gap-2" style="flex: 1 1 0; min-width: 0;">
      <!-- El buscador es quien se achica, hasta un mínimo usable de 10rem -->
      <ZapiSearchBar
      style="min-width: 10rem;"
      :modelValue="busqueda"
      :suggestions="suggestions"
      @complete="$emit('buscarProducto', $event)"
      @update:modelValue="$emit('update:busqueda', $event)"
    />
      <slot name="acciones" />
    </div>
  </div>
</template>

<script>
import ZapiBadgePill from '../atoms/ZapiBadgePill.vue';
import ZapiSearchBar from '../molecules/ZapiSearchBar.vue';
import ZapiBackButton from '../atoms/ZapiBackButton.vue';
import EmpresaService from '@/service/EmpresaService';

export default {
  name: 'ZapiHeader',
  components: { ZapiBadgePill, ZapiSearchBar, ZapiBackButton },
  props: {
    busqueda: { type: [String, Object], default: null },
    suggestions: { type: Array, default: () => [] },
    nombreSucursal: { type: String, default: 'Desconocida' },
    // revision_capturas.md (a): logo de la empresa guardado en el catálogo local (Dexie, catalogo.empresa_logo).
    // Opcional: se usa cuando la petición propia a /empresa falla (sin conexión) o mientras no llega.
    logoLocal: { type: String, default: null }
  },
  emits: ['update:busqueda', 'buscarProducto', 'reportarMerma'],
  data() {
    return {
      empresa: {}
    }
  },
  computed: {
    // Primero el logo recién pedido al servidor; si no hay, el del catálogo local
    logoVisible() {
      return (this.empresa && this.empresa.logo) || this.logoLocal || null;
    }
  },
  beforeCreate() {
    this.empresaService = new EmpresaService();
    this.empresaService.getFirstEmpresa().then((response) => {
      this.empresa = response.data;
    }).catch(e => console.error("Error cargando logo empresa:", e));
  }
}
</script>